"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERROR_KEY = exports.CLASSNAME_SPOT_ILLUSTRATION = exports.AVAILABLE_ILLUSTRATIONS = void 0;
var _SpotIllustration = require("./SpotIllustration.types");
var AVAILABLE_ILLUSTRATIONS = exports.AVAILABLE_ILLUSTRATIONS = Object.values(_SpotIllustration.Name);
var CLASSNAME_SPOT_ILLUSTRATION = exports.CLASSNAME_SPOT_ILLUSTRATION = 'Cozy__SpotIllustration';
var ERROR_KEY = exports.ERROR_KEY = 'SPOTILLUSTRATION';